import Phaser from "phaser";

/** Draws a filled 5-point star centered at (cx, cy) into an existing Graphics object. Shared by the level-complete overlay and the level-select tiles so both draw identical stars. */
export function drawStar(
  graphics: Phaser.GameObjects.Graphics,
  cx: number,
  cy: number,
  outerRadius: number,
  color: number,
): void {
  const points = 5;
  const innerRadius = outerRadius * 0.45;
  graphics.fillStyle(color, 1);
  graphics.beginPath();
  for (let i = 0; i < points * 2; i++) {
    const radius = i % 2 === 0 ? outerRadius : innerRadius;
    const angle = (Math.PI / points) * i - Math.PI / 2;
    const px = cx + Math.cos(angle) * radius;
    const py = cy + Math.sin(angle) * radius;
    if (i === 0) graphics.moveTo(px, py);
    else graphics.lineTo(px, py);
  }
  graphics.closePath();
  graphics.fillPath();
}
